import React, { createContext, useContext, useState, ReactNode } from 'react';
import Modal from '../components/Modal';
interface FileErrorContextType {
  showFileSizeError: (message: string, isFormatError?: boolean) => void;
}
const FileErrorContext = createContext<FileErrorContextType | undefined>(undefined);
export const useFileError = () => {
  const context = useContext(FileErrorContext);
  if (!context) {
    throw new Error('useFileError must be used within FileErrorProvider');
  }
  return context;
};
interface FileErrorProviderProps {
  children: ReactNode;
}
export const FileErrorProvider: React.FC<FileErrorProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isFormatError, setIsFormatError] = useState<boolean>(false);
  const showFileSizeError = (message: string, isFormatErrorParam: boolean = false) => {
    setErrorMessage(message);
    setIsFormatError(isFormatErrorParam);
    setShowModal(true);
  };
  return (
    <FileErrorContext.Provider value={{ showFileSizeError }}>
      {children}
      <Modal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setErrorMessage('');
          setIsFormatError(false);
        }}
        title={isFormatError ? "Error en el formato del archivo" : "Archivo demasiado grande"}
        onConfirm={() => {
          setShowModal(false);
          setErrorMessage('');
          setIsFormatError(false);
        }}
        confirmText="Entendido"
        cancelText=""
      >
        <p>
          {errorMessage || (isFormatError ? 'El formato del archivo no es válido.' : 'El archivo excede el tamaño máximo permitido.')}
        </p>
      </Modal>
    </FileErrorContext.Provider>
  );
};